import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import moment from 'moment'
import ContentHeader from '../../../Layout/ContentHeader'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import Loader from '../../../Global/Spinner'
import MapPointLocationAddress from '../../../Global/MapPointLocationAddress'
import InternalNotes from '../../../Global/InternalNotes/InternalNotes'
import { findArrayStatus } from '../../../../const/constStatuses'
import { GET_ONE_REPORT_BY_ID } from '../../../../graphql/Catalog/Reports/reports'
import ReportInfoUser from './components/ReportInfoUser'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'
import { objNameRoles } from '../../../../const/constRoles'
import TimeLines from '../../../Global/TimeLines/TimeLines'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT } from '../../../../graphql/Catalog/Status/statusRoleVisibility'
import ModalContent from '../../../Global/ModalContent'
import ModalStatus from './components/ModalChangeStatus/ModalStatus'
import { AuthContext } from '../../../../Auth/AuthContext'
import ReportTimer from './components/ReportTimer'

export const ReportsNew = () => {
  const { user } = useContext(AuthContext)
  const refModalStatus = useRef(null)
  const { id: _id } = useParams()
  const history = useHistory()

  //STATES:
  const [dataReport, setDataReport] = useState(null)
  const [currentStatus, setCurrentStatus] = useState(null)
  const [activeTime, setActiveTime] = useState('')
  const [statusOfRole, setStatusOfRole] = useState([])
  const [closeModal, setCloseModal] = useState(false)
  const [refetchNotes, setRefetchNotes] = useState(false)
  const [dataReportCityzen, setDataReportCityzen] = useState({
    name: 'N/A',
    address: 'N/A',
    phone: 'N/A',
    typeUser: 'N/A',
  })
  const [modal, setModal] = useState({
    modalId: null,
    size: 'extra',
    title: '',
    content: null,
  })

  //QUERIES:
  const {
    data: dataResp,
    loading,
    error,
    refetch,
  } = useQuery(GET_ONE_REPORT_BY_ID, {
    variables: {
      reportId: parseInt(_id),
    },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataStatusRole,
    loading: loadingStatusRole,
    error: errorStatusRole,
  } = useQuery(GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT, {
    variables: {
      type_status: 'Reports',
    },
    fetchPolicy: 'no-cache',
  })

  const foundStatusCurrentInStatusRole = (status_id) => {
    return statusOfRole.find((item) => item.status_id === status_id)
  }

  //EFFECTS:
  useEffect(() => {
    if (!loadingStatusRole && !errorStatusRole) {
      if (dataStatusRole) {
        setStatusOfRole(
          dataStatusRole.getAllStatusRoleByTypeStatusOfUserContext
        )
      }
    }
  }, [dataStatusRole, loadingStatusRole, errorStatusRole])

  useEffect(() => {
    if (modal.modalId) {
      document.getElementById(`spanModal${modal.modalId}`).click()
    }
  }, [modal])

  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
      setModal({
        title: '',
        content: null,
        modalId: null,
        size: 'extra',
      })
      setCloseModal(false)
      // setTimeout(() => {
      //   setRefetchNotes(!refetchNotes)
      // }, 300)
    }
  }, [closeModal])

  useEffect(() => {
    if (!loading) {
      if (_id) {
        if (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }

        if (!dataResp?.getOneReportById)
          return (
            toastSweetAlert({
              mode: 'errorToast',
              message: 'No se encontraron datos',
            }),
            history.push('/reports')
          )

        if (dataResp !== undefined && dataResp !== null) {
          const dataFetched = dataResp.getOneReportById
          const found_current_status = findArrayStatus(
            dataResp.getOneReportById?.status_id
          )

          let cityzenData = {
            name: 'N/A',
            address: 'N/A',
            phone: 'N/A',
            typeUser: 'N/A',
          }

          if (dataFetched.channel_capture === 'web') {
            cityzenData = dataFetched?.ReportCitizenOfUsers || dataReportCityzen
            cityzenData.typeUser = 'Ciudadano'
          }

          if (dataFetched.channel_capture === 'web_gestor') {
            cityzenData = dataFetched?.ReportToUsers || dataReportCityzen
            cityzenData.typeUser = 'Comunicante Interno'
          }

          if (dataFetched.channel_capture === 'web_anonymous') {
            cityzenData = dataFetched?.ReportToUsers || dataReportCityzen
            cityzenData.typeUser = 'Comunicante Interno'
          }

          if (dataFetched.channel_capture === 'app') {
            cityzenData = dataFetched?.ReportToUsers
            cityzenData.typeUser = 'Ciudadano'
          }

          if (dataFetched.channel_capture === 'tlajochat') {
            cityzenData =
              dataFetched?.UserTlajoChatOfReport || dataReportCityzen
            cityzenData.typeUser = 'Ciudadano'
          }

          setDataReportCityzen(cityzenData)
          setCurrentStatus(found_current_status)
          setDataReport(dataFetched)
        } else {
          return (
            toastSweetAlert({
              mode: 'errorToast',
              message: 'No se encontraron datos',
            }),
            history.push('/reports')
          )
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataResp, error, loading])

  //ESTO ESTABA PROVOCANDO RE RENDERS EN EL MAPA LO CUAL ESTABA OCASIONANDO GASTOS POR CADA SEGUNDO QUE PASABA. SE MOVIO LA LOGICA A UN COMPONENTE SEPARADO
  // useEffect(() => {
  //   if (
  //     dataReport?.citizen_send_date &&
  //     dataReport?.status_id != 7 &&
  //     dataReport?.status_id != 15
  //   ) {
  //     //7= Solucionado, 15 = cancelado
  //     const interval = setInterval(() => {
  //       const startDate = moment(dataReport.citizen_send_date)
  //       const now = moment()
  //       const duration = moment.duration(now.diff(startDate))
  //       let textTime = ''
  //       if (duration.years() > 0) textTime += `${duration.years()}A `
  //       if (duration.months() > 0) textTime += `${duration.months()}M `
  //       if (duration.days() > 0) textTime += `${duration.days()}D `
  //       if (duration.hours() > 0) textTime += `${duration.hours()}h `
  //       textTime += `${duration.minutes()}m ${duration.seconds()}s`
  //       setActiveTime(textTime)
  //     }, 1000)
  //     return () => clearInterval(interval)
  //   } else if (
  //     dataReport?.completed_at &&
  //     (dataReport?.status_id == 7 || dataReport?.status_id == 15)
  //   ) {
  //     //7= Solucionado, 15 = cancelado
  //     const startDate = moment(dataReport?.citizen_send_date)
  //     const endDate = moment(dataReport?.completed_at)
  //     const duration = moment.duration(endDate.diff(startDate))
  //     let textTime = ''
  //     if (duration.years() > 0) textTime += `${duration.years()}A `
  //     if (duration.months() > 0) textTime += `${duration.months()}M `
  //     if (duration.days() > 0) textTime += `${duration.days()}D `
  //     if (duration.hours() > 0) textTime += `${duration.hours()}h `
  //     textTime += `${duration.minutes()}m ${duration.seconds()}s`
  //     setActiveTime(textTime)
  //   }
  // }, [dataReport])

  const handleOpenModal = (e, reportId, report, folio) => {
    e.preventDefault()
    setModal({
      id: reportId,
      modalId: `modal${reportId}`,
      size: 'large',
      title: `Procesar reporte`,
      content: (
        <ModalStatus
          reportId={parseInt(reportId)}
          reportFolio={folio}
          reportData={report}
          user={user}
          groupCategory={report?.ReportToGroupCategory?.name}
          currentStatus={report?.StatusOfReport?.name}
          currentStatusId={report.status_id}
          refetchMain={refetch}
          setCloseModal={setCloseModal}
        />
      ),
    })
  }

  return (
    <>
      {loading || !dataReport ? (
        <div className="d-flex align-items-center justify-content-center">
          <Loader />
        </div>
      ) : (
        <>
          <ContentHeader
            title=""
            titleContent={
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <div>
                    <Link
                      className="btn btn-migrates-white mb-3"
                      to={`/reports`}
                    >
                      <i className="fas fa-long-arrow-alt-left" /> Atrás
                    </Link>
                    <h1 className="header-title">
                      Detalle del reporte - {dataReport?.folio}{' '}
                    </h1>
                  </div>
                  <ReportTimer
                    citizenSendDate={dataReport?.citizen_send_date}
                    completedAt={dataReport?.completed_at}
                    statusId={dataReport?.status_id}
                  />
                  {/* //ESTO ESTABA PROVOCANDO RE RENDERS EN EL MAPA LO CUAL ESTABA
                  OCASIONANDO GASTOS POR CADA SEGUNDO QUE PASABA. SE MOVIO LA
                  LOGICA A UN COMPONENTE SEPARADO PARA QUE NO SUCEDA */}
                  {/* {activeTime && (
                    <div className="d-flex flex-column align-items-end border border-secondary py-2 px-2 rounded">
                      <div style={{ fontSize: 12 }}>
                        <i className="fas fa-clock mr-1" />
                        Tiempo activo
                      </div>
                      <div>{activeTime}</div>
                    </div>
                  )} */}
                </div>
              </div>
            }
            breadcrumb=""
            windowTitle={`Vista detalle del reporte`}
          />

          <div className="row reports-new-container">
            {/**------- LEFT SECTION ------- */}
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 left-box">
              <div className="row">
                <div className="col-12">
                  <div className="reports">
                    <Box
                      classNameHeader="card-header py-1"
                      contentHeader={
                        <>
                          <h3 className="card-title pl-3 mt-0">
                            Datos generales
                          </h3>
                          <div className={`card-tools mr-2`}>
                            <div
                              style={{ fontSize: 13 }}
                              className={` px-2 rounded`}
                            >
                              <b className="mr-1" style={{ fontSize: 10 }}>
                                {/*Estatus:*/}
                                {foundStatusCurrentInStatusRole(
                                  dataReport.status_id
                                ) && (
                                  <button
                                    className="btn btn-sm btn-migrates"
                                    onClick={(e) =>
                                      handleOpenModal(
                                        e,
                                        dataReport.id,
                                        dataReport,
                                        dataReport?.folio
                                      )
                                    }
                                    title="Procesar reporte"
                                  >
                                    <i className="fas fa-cogs me-2 text-white"></i>
                                    {/* Procesar */}
                                  </button>
                                )}
                                <ProgressBarStatusReport
                                  statusReport={dataReport.StatusOfReport}
                                />
                              </b>
                            </div>
                          </div>
                        </>
                      }
                      content={
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Categoría</span>
                            <br />
                            <span className="content-details">
                              {dataReport?.ReportToGroupCategory?.icon && (
                                <img
                                  className="icon"
                                  src={dataReport?.ReportToGroupCategory?.icon}
                                  alt="category-icon"
                                />
                              )}
                              {dataReport?.ReportToGroupCategory?.name || 'N/A'}
                            </span>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Sub Categoría</span>
                            <br />
                            <span className="content-details">
                              {dataReport?.ReportToGroupCategorySub?.icon && (
                                <img
                                  className="icon"
                                  src={
                                    dataReport?.ReportToGroupCategorySub?.icon
                                  }
                                  alt="sub-category-icon"
                                />
                              )}
                              {dataReport?.ReportToGroupCategorySub?.name ||
                                'N/A'}
                            </span>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Fecha inicio</span>
                            <br />
                            {!dataReport?.start_date ? (
                              <span className="content-details">'N/A'</span>
                            ) : (
                              <span className="content-details">
                                {moment(dataReport.start_date).format(
                                  'DD/MM/YYYY'
                                ) +
                                  ', ' +
                                  moment(dataReport.start_date).format('LT') ||
                                  '--'}
                              </span>
                            )}
                          </div>
                          {dataReport?.due_date && (
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                              <span className="title-details">Fecha fin</span>
                              <br />
                              <span className="content-details">
                                {moment(dataReport.due_date).format(
                                  'DD/MM/YYYY'
                                ) +
                                  ', ' +
                                  moment(dataReport.due_date).format('LT') ||
                                  '--'}
                              </span>
                            </div>
                          )}
                          {dataReport?.completed_at && (
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                              <span className="title-details">
                                Fecha completado
                              </span>
                              <br />
                              <span className="content-details">
                                {moment(dataReport.completed_at).format(
                                  'DD/MM/YYYY'
                                ) +
                                  ', ' +
                                  moment(dataReport.completed_at).format(
                                    'LT'
                                  ) || '--'}
                              </span>
                            </div>
                          )}
                          {dataReport?.planning_date && (
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                              <span className="title-details">
                                Fecha planificada
                              </span>
                              <br />
                              <span className="content-details">
                                {moment(dataReport.planning_date).format(
                                  'DD/MM/YYYY'
                                ) +
                                  ', ' +
                                  moment(dataReport.planning_date).format(
                                    'LT'
                                  ) || '--'}
                              </span>
                            </div>
                          )}
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Jurisdicción</span>
                            <br />
                            <span className="content-details">
                              {dataReport?.JurisdictionOfReport?.name || 'N/A'}
                            </span>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Zona</span>
                            <br />
                            <span className="content-details">
                              {dataReport?.JurisdictionsSubOfReport?.name ||
                                'N/A'}
                            </span>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Colonia</span>
                            <br />
                            <span className="content-details">
                              {dataReport?.ColonyOfReport?.name || 'N/A'}
                            </span>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">
                              {dataReportCityzen.typeUser}
                            </span>
                            <br />
                            <span className="content-details">
                              {dataReportCityzen.name}
                            </span>
                          </div>

                          {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">
                              Gestor asignado
                            </span>
                            <br />
                            <span className="content-details">
                              {dataReport?.ReportsToResponsible?.name
                                ? dataReport.ReportsToResponsible.name
                                : 'N/A'}
                            </span>
                          </div> */}

                          {dataReport?.data_form_json && (
                            <>
                              {(() => {
                                try {
                                  const dataForm = JSON.parse(
                                    dataReport.data_form_json
                                  )
                                  if (
                                    typeof dataForm !== 'object' ||
                                    dataForm === null ||
                                    !Array.isArray(dataForm)
                                  )
                                    return Object.entries(dataForm).map(
                                      ([key, value]) => (
                                        <>
                                          {value &&
                                            value !== '' &&
                                            (typeof value !== 'object' ||
                                              value === null ||
                                              !Array.isArray(value)) && (
                                              <div
                                                className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3"
                                                key={key}
                                              >
                                                <span className="title-details">
                                                  {key}
                                                </span>
                                                <br />
                                                <span className="content-details">
                                                  {value}
                                                </span>
                                              </div>
                                            )}
                                        </>
                                      )
                                    )
                                } catch (e) {
                                  return null
                                }
                              })()}
                            </>
                          )}
                        </div>
                      }
                    />
                  </div>
                </div>

                <div className="col-12 reports">
                  <ReportAddress
                    address={dataReport?.AddressOfReport}
                    channel={dataReport?.channel_capture}
                  />
                </div>
                <div className="col-12 reports">
                  <ReportAttachments
                    attachments={dataReport?.AttachmentsOfReport}
                  />
                </div>
              </div>
            </div>

            {/**------- RIGHT SECTION ------- */}
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 right-box">
              <div className="row">
                <div className="col-12">
                  <InternalNotes
                    document_id={_id ? parseInt(_id) : 0}
                    flagSwitchInternalMode={
                      dataReport?.channel_capture === 'app' ? true : false
                    }
                    OnlyInternalMessages={
                      dataReport?.channel_capture === 'app' ? false : true
                    }
                    refetchNotes={refetchNotes}
                  />
                </div>
                <div className="col-12">
                  <TimeLines document_id={parseInt(_id)} />
                </div>
                {dataReport?.currentReportAndReportsRelated?.reportsRelated
                  ?.length > 0 && (
                  <div className="col-12">
                    <ReportsRelated
                      dataRelated={dataReport?.currentReportAndReportsRelated}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row reports-new-container">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <div className="row">
                <div className="col-12 reports">
                  <ReportInfoUser
                    report={dataReport}
                    user={dataReportCityzen}
                    // user={
                    //   dataReport &&
                    //   (dataReport?.ReportCitizenOfUsers ||
                    //   (dataReport?.ReportToUsers?.type_user == 'web' &&
                    //     dataReport?.ReportToUsers?.name !== 'Anónimo' &&
                    //     dataReport?.ReportToUsers?.phone !== '0000000000' &&
                    //     dataReport?.ReportToUsers?.address !== 'conocido')
                    //     ? dataReport.ReportCitizenOfUsers
                    //     : dataReport.ReportToUsers)
                    // }
                  />
                </div>
                {dataReport && dataReport.channel_capture === 'app' && (
                  <div className="col-12 evaluation">
                    <ReportsEvaluation evaluation={dataReport?.evaluation} />
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <div className="col-12 reports">
                <Box
                  title={'Datos del responsable'}
                  classNameHeader="card-header py-1"
                  content={
                    <div className="row">
                      {dataReport && !dataReport.ReportsToResponsible ? (
                        <div className="col-12">
                          <h4>
                            Este reporte aún no ha sido asignado a ningún gestor
                          </h4>
                        </div>
                      ) : (
                        <>
                          <div className="col-12 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Nombre</span>
                            <br />
                            <span className="content-details view-reports-users">
                              {dataReport?.ReportsToResponsible?.name}
                            </span>
                          </div>
                          <div className="col-12 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <span className="title-details">Correo</span>
                            <br />
                            <span className="content-details">
                              {dataReport?.ReportsToResponsible?.email}
                            </span>
                          </div>
                          <div className="col-12 mb-3">
                            <span className="title-details">Cargo</span>
                            <br />
                            <span className="content-details">
                              {
                                dataReport?.ReportsToResponsible
                                  ?.JobPositionOfUser?.name
                              }
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        </>
      )}

      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModalStatus}
      />

      <ModalContent
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={() => {
          setModal({
            title: '',
            content: null,
            modalId: null,
            size: 'extra',
          })
        }}
        content={modal.content}
      />
    </>
  )
}

const ReportsEvaluation = ({ evaluation }) => {
  if (!evaluation) {
    return (
      <Box
        title="Evaluación"
        classNameHeader="card-header py-1"
        content={'Aun no hay una evaluación'}
      />
    )
  }

  const icon =
    evaluation === 1
      ? 'fas fa-frown'
      : evaluation === 2
      ? 'fas fa-meh'
      : 'fas fa-smile'
  const color =
    evaluation === 1
      ? 'fas-fa-red'
      : evaluation === 2
      ? 'fas-fa-yellow'
      : 'fas-fa-green'
  const description =
    evaluation === 1 ? 'Mala' : evaluation === 2 ? 'Regular' : 'Buena'
  const classEvaluation =
    evaluation === 1
      ? 'bad-evaluation'
      : evaluation === 2
      ? 'regular-evaluation'
      : 'good-evaluation'

  return (
    <Box
      classNameHeader="card-header py-1"
      contentHeader={<h3 className="card-title pl-3 mt-0">Evaluación</h3>}
      content={
        <>
          <div className="row">
            <div className={`col-12 ${classEvaluation}`}>
              <i className={`fas ${icon} fa-2x ${color}`} />
              <span className="content-details ml-2">{description}</span>
            </div>
          </div>
        </>
      }
    />
  )
}

const ReportAttachments = ({ attachments }) => {
  const MySwal = withReactContent(Swal)
  let imageWidth = 500
  let imageHeight = 440
  let flagKeepImageSize = false

  const [uniqueUser, setUniqueUser] = useState([])

  useEffect(() => {
    if (attachments) {
      const uniqueUsers = attachments.reduce((acc, attachment) => {
        if (!acc.some((user) => user.user_id === attachment.user_id)) {
          acc.push({
            user_id: attachment.user_id,
            user: attachment.UserOfReportAttachment,
          })
        }
        return acc
      }, [])
      setUniqueUser(uniqueUsers)
    }
  }, [attachments])

  const switchFile = (type_file) => {
    const data = {
      pdf: {
        icon: 'fas fa-file-pdf',
        text: 'PDF',
      },
      img: {
        icon: 'fas fa-image',
        text: 'IMG',
      },
    }
    return (
      <>
        {data[type_file ? type_file : 'img']?.text}
        <i
          className={`${data[type_file ? type_file : 'img'].icon} fa-2x ml-2`}
        />
      </>
    )
  }

  const handleModalImage = (url) => {
    let resetImageSize = () => {
      imageWidth = 500
      imageHeight = 440
    }

    MySwal.fire({
      html: `
      <button id="increase-size-btn" class="btn btn-orange" style="margin-bottom:10px;">
      Aumentar tamaño
      </button>
      <img src="${url}" style="display:block;margin:auto;width:${imageWidth}px;height:${imageHeight}px;" />
      `,
      didOpen: () => {
        const btn = document.getElementById('increase-size-btn')
        if (btn) {
          btn.onclick = () => {
            imageWidth = imageWidth + 300
            imageHeight = imageHeight + 300
            flagKeepImageSize = true
            MySwal.close()
            handleModalImage(url)
          }
        }
      },
      willClose: () => {
        if (!flagKeepImageSize) resetImageSize()
        else flagKeepImageSize = false
      },
      width: imageWidth + 40,
      heightAuto: false,
      customClass: {
        popup: '',
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
      confirmButtonText: 'Aceptar',
    })
  }

  console.log({ uniqueUser })

  return (
    <Box
      title="Archivos adjuntos"
      classNameHeader="card-header py-1"
      content={
        <>
          {attachments?.length === 0 ? (
            'No hay archivos adjuntos'
          ) : (
            <div className="d-flex flex-wrap row">
              {uniqueUser.map((user) => {
                let findAttachment = attachments.filter((value) => {
                  return value?.user_id == user.user_id
                })
                if (findAttachment.length > 0) {
                  return (
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-3">
                      <span className="title-details" style={{ width: '100%' }}>
                        {user.user?.name}{' '}
                        {user?.user?.RoleOfUser
                          ? `(${user?.user?.RoleOfUser.role_name})`
                          : ''}
                      </span>
                      <br />
                      {findAttachment.map((attachment) => {
                        if (!attachment?.url) {
                          return null
                        }

                        return (
                          <div key={attachment.id} className="btn btn-light">
                            {attachment?.type_file === 'img' ? (
                              <div className='d-flex flex-column align-items-center'>
                              <a
                                className="link-primary documentLink mb-1"
                                style={{ textDecoration: 'none' }}
                                as="button"
                                title="Descargar"
                                onClick={() =>
                                  handleModalImage(
                                    attachment.url,
                                    attachment.id
                                  )
                                }
                              >
                                <img
                                  src={attachment.url}
                                  alt=""
                                  width="80px"
                                  height="80px"
                                />
                                {/* {switchFile(attachment?.type_file)} */}
                              </a>
                              </div>
                            ) : (
                              <a
                                className="link-primary documentLink"
                                style={{ textDecoration: 'none' }}
                                as="button"
                                href={attachment.url}
                                target="_blank"
                                rel="noreferrer"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Descargar"
                              >
                                {switchFile(attachment?.type_file)}
                              </a>
                            )}
                          </div>
                        )
                      })}
                    </div>
                  )
                }
                return null
              })}
            </div>
          )}
        </>
      }
    />
  )
}

// const ReportObservations = ({ observations }) => {
//   return (
//     <Box
//       title={<TitleBox icon="fas fa-comments" text="Observaciones" />}
//       classNameHeader="card-header py-1"
//       content={
//         <>
//           {observations?.length === 0 ? (
//             'Aun no hay observaciones'
//           ) : (
//             <>
//               {observations?.map((observation) => {
//                 return (
//                   <div key={observation.id} className="mb-1">
//                     <i>Mensaje:</i> {observation?.content || 'N/A'}
//                     <br />
//                     <i>Autor:</i>{' '}
//                     {observation?.UserOfReportObservation?.name || 'N/A'}
//                     <hr />
//                   </div>
//                 )
//               })}
//             </>
//           )}
//         </>
//       }
//     />
//   )
// }

const ReportAddress = ({ address, channel }) => {
  if (!address) {
    return (
      <Box
        title="Ubicación"
        classNameHeader="card-header py-1"
        content={'Aun no hay dirección'}
      />
    )
  }

  const {
    street,
    zipcode,
    state,
    city,
    reference,
    latitude,
    longitude,
    address_full,
  } = address

  return (
    <Box
      title="Ubicación"
      classNameHeader="card-header py-1"
      content={
        <div className="row">
          <div className="col-12 mb-3">
            <span className="title-details">Dirección</span>
            <br />
            <span className="content-details">
              {/* {street ? `${street}, ` : ''}
              {zipcode ? `C.P. ${zipcode}, ` : ''}
              {city ? `${city}, ` : ''}
              {state ? `${state} ` : ''} */}
              {channel === 'app' ? (
                <>{street ? `${street}, ` : ''}</>
              ) : (
                <>{address_full ? `${address_full}, ` : ''}</>
              )}
            </span>
          </div>
          <div className="col-12 mb-3">
            <span className="title-details">Referencia</span>
            <br />
            <span className="content-details">
              {reference ? `${reference}` : 'N/A'}
            </span>
          </div>
          {latitude && longitude && (
            <div className="col-12">
              <MapPointLocationAddress
                latitude={latitude}
                longitude={longitude}
              />
            </div>
          )}
        </div>
      }
    />
  )
}

const ReportsRelated = ({ dataRelated }) => {
  const [relateds, setRelateds] = useState([])

  useEffect(() => {
    const list = [{ ...dataRelated.currentReport }]
    dataRelated.reportsRelated.map((item) => list.push({ ...item }))
    list.sort((a, b) => a.id - b.id) //ordenar lista por por id
    setRelateds(list)
  }, [dataRelated])

  const getRelatedMain = () => {
    if (relateds.length === 0) return 'N/A'
    const found = relateds.find((item) => item.isOriginal === true)
    if (!found) return 'N/A'
    return found.folio
  }

  const getRelatedChilds = () => {
    if (relateds.length === 0) return 'N/A'
    const found = relateds.filter((item) => item.isOriginal === false)
    if (!found) return 'N/A'
    return found.map((item) => (
      <div key={item.id} className="content-details">
        {item.folio}
      </div>
    ))
  }

  return (
    <Box
      title="Reportes relacionados"
      classNameHeader="card-header py-1"
      classCardBody="card-body pt-0"
      content={
        <div className="row">
          <div className="col-12">
            <span className="title-details">
              <b>Reporte original</b>
            </span>
            <br />
            <span className="content-details">
              {(relateds.length > 0 && getRelatedMain()) || 'N/A'}
            </span>
          </div>
          <div className="col-12">
            <span className="title-details">
              <b>Reportes relacionados</b>
            </span>
            <br />
            {(relateds.length > 0 && getRelatedChilds()) || (
              <span className="content-details">
                No hay reportes relacionados
              </span>
            )}
          </div>
        </div>
      }
    />
  )
}

const TitleBox = ({ icon, text }) => {
  return (
    <>
      <i className={`${icon} pr-1`} style={{ fontSize: 12 }} />
      {text}
    </>
  )
}

export default ReportsNew
